import PropTypes from "prop-types";
import React from "react";

import { Container, CssBaseline, useMediaQuery, useScrollTrigger } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import Banner from "../shared/Banner";
import Footer from "../shared/Footer";
import MainHeader from "../shared/MainHeader";
import ScrollTop from "../../components/_common/BackToTop";
import SkipList from "../../components/_common/SkipList";

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        padding: theme.spacing(0, 2, 2, 2),
        maxWidth: 1512,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0, 1, 0, 1),
        },
    },
}));

function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 20,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
};

const HomeView = (props) => {
    const classes = useStyles();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"));

    return (
        <React.Fragment>
            <Container maxWidth={false} disableGutters>
                <CssBaseline />
                {/* <SkipList /> */}
                <header>
                    <ElevationScroll {...props}>
                        <>
                            <div id="back-to-top-anchor" />
                            <SkipList />
                            <MainHeader isMobile={isMobile} />
                        </>
                    </ElevationScroll>

                    <Banner isMobile={isMobile} />
                </header>

                <Container
                    maxWidth={"lg"}
                    className={classes.mainContainer}
                    id={"the-main-container"}
                    component={"main"}
                >
                    {props.children}
                </Container>

                <footer>
                    <Footer isMobile={isMobile} />
                </footer>
            </Container>

            <ScrollTop />
        </React.Fragment>
    );
};

export default HomeView;
